import { render, staticRenderFns } from "./TrashList.vue?vue&type=template&id=416ab398&scoped=true&"
import script from "./TrashList.vue?vue&type=script&lang=js&"
export * from "./TrashList.vue?vue&type=script&lang=js&"
import style0 from "./TrashList.vue?vue&type=style&index=0&id=416ab398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416ab398",
  null
  
)

export default component.exports